import { graphql, useFragment } from "@/gql"
import { ProjectDesktopContentFragment, ProjectMetadataFragmentDoc, ProjectMobileContentFragment } from "@/gql/graphql"
import { Text } from "@/elements"
import { CreditsMetadataSection, MoreProjectsMetadataSection } from "@/components"
import { ProjectClientSection } from "./ProjectClientSection"
import type { NovaSession } from "@/types"

graphql(`
  fragment ProjectMetadata on CreativeWorkPortfolioProject {
    id
    title
    description
    category {
      __typename
      id
      name
    }

    creative {
      id
      __typename
      ... on IndividualCreative {
        ...MoreProjectsMetadataSection
      }
    }

    ...CreditsMetadataSection
    ...ProjectClientSection
  }
`)

interface Props {
  project: ProjectMobileContentFragment | ProjectDesktopContentFragment
  mobile?: boolean
  serverSession: NovaSession | null
}

export const ProjectMetadata: React.FC<Props> = ({ mobile, serverSession, ...props }) => {
  const project = useFragment(ProjectMetadataFragmentDoc, props.project)

  const creative = project?.creative?.__typename === "IndividualCreative" ? project?.creative : null

  return (
    <div className="flex flex-col gap-6">
      <div>
        <div className="mb-2">
          <Text variant="body1" className="text-fg-2">
            {project?.category?.name}
          </Text>
        </div>
        <Text variant="h4">{project?.title}</Text>
      </div>
      <ProjectClientSection project={project} />
      {project?.description && <Text className="text-fg-2">{project?.description}</Text>}
      <CreditsMetadataSection project={project} mobile={mobile} serverSession={serverSession} />
      {creative && <MoreProjectsMetadataSection creative={creative} />}
    </div>
  )
}
